// @ts-nocheck
export default `Movology Privacy Notice — Capture® Dashboard

This notice summarizes how Movology, Inc. ("Movology," "we," "us") collects and uses information when you sign in to or use the Capture® dashboard. The full Privacy Policy is published at https://movology.com/privacy and prevails over this summary if there is any conflict.

1. Information we collect

(a) Account information you provide: name, work email, phone, company, website URL, and password (stored hashed). When you complete the new-account form, this information is also forwarded to our marketing CRM (HubSpot) so our team can support onboarding.

(b) Authentication metadata: ID tokens issued by Google Firebase Authentication, sign-in timestamps, and the IP address of the device you sign in from.

(c) Usage data from the dashboard: pages viewed, actions taken (forms created, integrations connected, exports downloaded), and diagnostic logs. We use Google Analytics and Lucky Orange to understand how the product is used.

(d) Capture® event data your visitors generate on your website when our snippet is installed — abandonment events, form-field captures, and identity resolution outputs. This data is processed on your behalf as a data processor.

2. How we use information

We use account and authentication data to operate the dashboard, secure your session, and provide customer support. We use usage data and Capture® event data to deliver, measure, and improve the service. We do not sell personal information.

3. Sharing

We share information with vendors who process data on our behalf under written contracts: Google (Firebase, Google Analytics), HubSpot, Stripe (billing), and infrastructure providers. We may disclose information when required by law or to protect rights, property, or safety.

4. Retention

Account records are retained while your account is active and for a reasonable archival period after closure. Capture® event data retention is governed by your subscription plan and configuration; you can export or request deletion at any time.

5. Your choices and rights

You can update or delete most account fields from the Settings tab. You can request a copy of your personal data, ask us to correct it, or ask us to delete it by contacting privacy@movology.com. Residents of California, the EU/EEA, and the UK have additional rights under applicable laws including access, portability, and objection rights.

6. International transfers

Data is stored and processed in the United States. By using the dashboard you consent to transfer of your information to the United States subject to the safeguards described in our full Privacy Policy.

7. Security

We use TLS in transit, encryption at rest where appropriate, and role-based access controls. No system is perfectly secure; promptly notify us at security@movology.com if you suspect unauthorized access.

8. Changes

We may update this notice. Material changes will be communicated via the dashboard or by email. The "last updated" date is maintained on the canonical Privacy Policy page.

9. Contact

Movology, Inc. — privacy@movology.com — https://movology.com/contact

For the full Privacy Policy, visit https://movology.com/privacy.`;
